import { AvailableRow, Timesheet, TimesheetRow } from '../../../model/timesheet.model';

// Mock data for UI demonstration — no endpoints exist yet.

const row = (
  id: string,
  clientName: string,
  projectName: string,
  projectColor: string,
  workType: string,
  billable: boolean,
  hours: number[],
): TimesheetRow => ({
  id,
  clientName,
  projectName,
  projectColor,
  workType,
  billable,
  fromOrg: true,
  hours,
});

/** Current week — in progress, not submitted yet. */
const draftRows = (): TimesheetRow[] => [
  row('acme-redesign-design', 'Acme', 'Website redesign', '#b4674d', 'Design', true, [3, 4, 2.5, 0, 4, 0, 0]),
  row('acme-redesign-meet', 'Acme', 'Website redesign', '#b4674d', 'Meetings', false, [0, 1, 0, 1.5, 0, 0, 0]),
  row('bolt-mobile-dev', 'Bolt', 'Mobile app', '#4d7ab4', 'Engineering', true, [4, 2, 5, 4.5, 3, 0, 0]),
];

/** Previous week — already approved, therefore locked. */
const approvedRows = (): TimesheetRow[] => [
  row('acme-redesign-design', 'Acme', 'Website redesign', '#b4674d', 'Design', true, [6, 5, 4, 6, 3, 0, 0]),
  row('acme-redesign-meet', 'Acme', 'Website redesign', '#b4674d', 'Meetings', false, [0, 1, 1, 0, 1, 0, 0]),
  row('bolt-mobile-dev', 'Bolt', 'Mobile app', '#4d7ab4', 'Engineering', true, [2, 2, 3, 2, 4, 0, 0]),
];

export const emptySheet = (): Timesheet => ({
  status: 'draft',
  reviewer: 'Maria Lopez',
  rows: draftRows().map(r => ({ ...r, hours: [0, 0, 0, 0, 0, 0, 0] })),
});

/** Keyed by week offset relative to the current week. */
export const initialSheets = (): Record<number, Timesheet> => ({
  0: {
    status: 'draft',
    reviewer: 'Maria Lopez',
    rows: draftRows(),
  },
  [-1]: {
    status: 'approved',
    reviewer: 'Maria Lopez',
    reviewedOn: 'Monday, 10:24',
    rows: approvedRows(),
  },
  [-2]: {
    status: 'rejected',
    reviewer: 'Maria Lopez',
    rejectionNote: 'Thursday shows 12 hours on a single project. Please split it across work types.',
    rows: approvedRows(),
  },
});

/** Projects the organization gave this person, minus what is already on the sheet. */
export const availableRows: AvailableRow[] = [
  {
    id: 'acme-support-dev',
    clientName: 'Acme',
    projectName: 'Support',
    projectColor: '#b4674d',
    workType: 'Engineering',
    billable: true,
    fromOrg: true,
  },
  {
    id: 'acme-support-qa',
    clientName: 'Acme',
    projectName: 'Support',
    projectColor: '#b4674d',
    workType: 'QA',
    billable: true,
    fromOrg: true,
  },
  {
    id: 'bolt-mobile-qa',
    clientName: 'Bolt',
    projectName: 'Mobile app',
    projectColor: '#4d7ab4',
    workType: 'QA',
    billable: true,
    fromOrg: true,
  },
  {
    id: 'bolt-mobile-meet',
    clientName: 'Bolt',
    projectName: 'Mobile app',
    projectColor: '#4d7ab4',
    workType: 'Meetings',
    billable: false,
    fromOrg: true,
  },
  {
    id: 'internal-learning',
    clientName: 'Internal',
    projectName: 'Growth',
    projectColor: '#6b7a5c',
    workType: 'Learning',
    billable: false,
    fromOrg: true,
  },
  {
    id: 'internal-admin',
    clientName: 'Internal',
    projectName: 'Operations',
    projectColor: '#6b7a5c',
    workType: 'Admin',
    billable: false,
    fromOrg: true,
  },
];
